<template>
    <div :class="fieldClass">
        <input type="checkbox" :name="field" :id="field" :disabled="isDisabled" :checked="isChecked" @change="cheboxUpdate($event)" :value="value">
        <label v-if="isLink" :for="field" v-html="fieldLabel"></label>
        <label v-else :for="field"> {{ fieldLabel }} </label>
        <p v-show="!isValid" class="rgErrorMessage"> {{ errorText }} </p>
    </div>
</template>
<script>
    export default {
        name: 'CheckBox',
        inject:['page'],
        props:{
            isChecked: {type: Boolean, default: false},
            isDisabled: {type: Boolean, default: false},
            fieldClass: {type: String, default: 'squareCheckbox'},
            field: {type: String},
            fieldLabel: {type: String},
            isLink: {type: Boolean, default: false },
            value: {type: String},

            isValid: { type: Boolean, default: true},
            errorText: {type: String},
        },
        methods:{
            cheboxUpdate(e){
                let isChecked =  e.target.checked
                let inputs = document.getElementsByTagName("input");
                inputs && [...inputs].forEach(el =>{
                    if(el.name.indexOf('cfgCard') == 0) {
                        if(el.name != e.target.name){
                            el.checked = false;
                        }
                    }
                })
                
                // switch(this.page){
                //     case 'Comparator':
                //     case 'Modal':
                //         this.$emit('checked-item', isChecked);
                //         break;
                //     default:
                //         this.$emit('checked-item', isChecked);
                //         break;
                // }

                this.$emit('checked-item', isChecked);
            }
        }
    }
</script>
<style lang="scss">
    @import './CheckBox.scss';
</style>